/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { INurse } from 'app/shared/model/nurse.model';
import { Specimen } from 'app/shared/model/enumerations/specimen.model';
import { PatientCondition } from 'app/shared/model/enumerations/patient-condition.model';

export interface IIntraOPNursingRecord {
  id?: string;
  procedureStart?: number | null;
  procedureEnd?: number | null;
  specimen?: keyof typeof Specimen | null;
  timeSent?: number | null;
  timeOfReport?: number | null;
  countsCorrect?: boolean;
  surgeonInformed?: boolean;
  timeInformed?: number | null;
  actionRemarks?: string | null;
  actionTaken?: boolean;
  conditionAtEnd?: keyof typeof PatientCondition | null;
  equipmentProblem?: boolean;
  equipmentProblemNotes?: string | null;
  actionNotes?: string | null;
  implant?: boolean;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  scrubNurse?: INurse;
  circulatingNurse?: INurse;
}

export const defaultValue: Readonly<IIntraOPNursingRecord> = {
  countsCorrect: false,
  surgeonInformed: false,
  actionTaken: false,
  equipmentProblem: false,
  implant: false,
  active: false,
};
